export const STATION_SEARCH_REQUEST           = "STATION_SEARCH_REQUEST";
export const STATION_SEARCH_ERROR             = "STATION_SEARCH_ERROR";
export const STATION_SEARCH_SUCCESS           = "STATION_SEARCH_SUCCESS";
export const STATION_SEARCH_CLEAR             = "STATION_SEARCH_CLEAR";
export const LOAD_SUGGESTED_STATIONS_SUCCESS  = "LOAD_SUGGESTED_STATIONS_SUCCESS";
export const LOAD_RECENT_STATIONS_SUCCESS     = "LOAD_RECENT_STATIONS_SUCCESS";
